import { HEX_COLOR_REGEX, DEFAULT_PICKER_COLOR } from "../constants";

function isHexColor(value) {
  return typeof value === "string" && HEX_COLOR_REGEX.test(value.trim());
}

function toFullHex(value) {
  if (!isHexColor(value)) return DEFAULT_PICKER_COLOR;
  const clean = value.trim().slice(1).toLowerCase();
  if (clean.length === 3) {
    return `#${clean
      .split("")
      .map((char) => char + char)
      .join("")}`;
  }
  return `#${clean}`;
}

function channelLuminance(channel) {
  const value = channel / 255;
  return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
}

function relativeLuminance(hex) {
  const full = toFullHex(hex).slice(1);
  const [red, green, blue] = [0, 2, 4].map((start) =>
    channelLuminance(parseInt(full.slice(start, start + 2), 16)),
  );
  return 0.2126 * red + 0.7152 * green + 0.0722 * blue;
}

function contrastRatio(first, second) {
  const a = relativeLuminance(first);
  const b = relativeLuminance(second);
  return (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
}

function getContrastText(hex) {
  return contrastRatio(hex, "#ffffff") >= contrastRatio(hex, "#000000")
    ? "#ffffff"
    : "#000000";
}

export { isHexColor, toFullHex, contrastRatio, getContrastText };
